import axios from "axios";
import {Mrbg} from "./Mrbg.js";
import { mrbgStore } from '../components/mrbg/mrbgRedux/index.js'

axios.defaults.withCredentials = true;

const mrbgS2S = (formID,formData,op,or,showLoader=true, blobResponse)=>{

  const hdr = {
    'X-Mrbg-Tk'  : localStorage.getItem('token'),
    'X-Mrbg-Or'  : or,
    'X-Mrbg-Op'  : op,
    'X-Mrbg-Path': window.location.pathname
  };

  if( !formData )
    formData = new FormData();

  var mainSelect = document.getElementByDataID('mainSelectAside');
  if( mainSelect ){
    formData.append(mainSelect.getAttribute('name'),mainSelect.value)
  }

  if( showLoader && document.getElementByDataID('mrbgLoader') )
    document.getElementByDataID('mrbgLoader').style.display='block';

  const axiosConfig = {
    url: `${mrbgStore.getState().url}/Api/Dispatcher.php${window.location.search}`,
    method: 'POST',
    headers: hdr,
    data: formData
  };

  if( blobResponse )
    axiosConfig.responseType = 'blob';

  return axios(axiosConfig)
    .then(async res=>{
      const contentType = res.headers['content-type'] || '';

      // IF IS JSON ________________________________________________________________
      if( contentType.includes('application/json') || (formID && contentType.startsWith('text/')) ){
        let data = res.data;

        if( typeof data=='object' ){
          if( Object.hasOwn(data,'__RL') || Object.hasOwn(data,'__NL') || Object.hasOwn(data,'__BL') ){
            if( Object.hasOwn(data,'__RL') )
              window.location.reload();
            else if( Object.hasOwn(data,'__NL') )
              window.location.href = data['__NL'];
            else if( Object.hasOwn(data,'__BL') )
              window.history.back();
            return false;
          }
        }
        return Mrbg.dataProcessing( formID, data, res.status );
      }
      // IF IS FILE ________________________________________________________________
      else if( Object.hasOwn(res.headers,'content-disposition') ){

        const disposition = res.headers['content-disposition'];
        let filename      = 'downloaded.file';

        if( disposition && disposition.indexOf('filename=') !== -1 ){
          const match = disposition.match(/filename="?([^"]+)"?/);
          if( match && match[1] )
            filename = decodeURIComponent(match[1]);
        }

        const blob    = new Blob([res.data], { type: contentType });
        const link    = document.createElement('a');
        link.href     = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      // IF IS TEXT
      else{

        if( document.getElementByDataID('mrbgLoader') )
          document.getElementByDataID('mrbgLoader').removeAttribute('style');
        return res.data;
      }

      if( document.getElementByDataID('mrbgLoader') )
        document.getElementByDataID('mrbgLoader').removeAttribute('style');
    })
    .catch(async err=>{

      if( document.getElementByDataID('mrbgLoader') )
        document.getElementByDataID('mrbgLoader').removeAttribute('style');
      var data = err.response?.data;

      if( typeof data=='object' && Object.keys(data).length ){
        if( !Object.hasOwn(data,'__RM') && (Object.hasOwn(data,'__EI')||Object.hasOwn(data,'__II')) ){
          data.__RM =
            ( Object.hasOwn(data,'__II') )?
              'فیلد‌های مشحص شده معتبر نیستند.':
              '';
          if( Object.hasOwn(data,'__EI') )
            data.__RM += 'فیلد‌های خالی را پر کنید.';
        }
      }

      return Mrbg.dataProcessing( formID, data );
    });
}
export default mrbgS2S;